import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/search.svg'
import _imports_1 from '../assets/favorite.svg'
import _imports_2 from '../assets/applied.svg'
import _imports_3 from '../assets/mypage.svg'


const _hoisted_1 = {
  class: "main-footer",
  app: ""
}
const _hoisted_2 = ["checked"]
const _hoisted_3 = ["checked"]
const _hoisted_4 = ["checked"]
const _hoisted_5 = { for: "main-footer-applied-tab" }
const _hoisted_6 = ["checked"]

import { ProjectStore } from "../store/ProjectStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const projectStore = ProjectStore();
// タブをクリックされたら表示内容を変更する（現状開いているタブの場合は何もしない）
const tabClicked = (id: number) => {
  // タイトル変更
  switch (id) {
    case 0:
      document.title = "募集中案件";
      projectStore.setSelectedTab(0);
      break;
    case 1:
      document.title = "応募案件";
      // projectStore.setSelectedStatus(1)
      projectStore.setSelectedTab(1);
      break;
    case 2:
      document.title = "マイページ";
      projectStore.setSelectedTab(2);
      break;
    case 3:
      document.title = "お気に入り";
      projectStore.setSelectedTab(3);
      break;
    default:
      document.title = "";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      class: "main-footer-search",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (tabClicked(0)))
    }, [
      _createElementVNode("input", {
        id: "main-footer-search-tab",
        type: "radio",
        name: "tab_switch",
        checked: _unref(projectStore).selectedTab == 0
      }, null, 8 /* PROPS */, _hoisted_2),
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        for: "main-footer-search-tab",
        name: "tab-label"
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "探す",
          class: "main-footer-search-icon"
        })
      ], -1 /* HOISTED */))
    ]),
    _createElementVNode("div", {
      class: "main-footer-favorite",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (tabClicked(3)))
    }, [
      _createElementVNode("input", {
        id: "main-footer-favorite-tab",
        type: "radio",
        name: "tab_switch",
        checked: _unref(projectStore).selectedTab == 3
      }, null, 8 /* PROPS */, _hoisted_3),
      _cache[5] || (_cache[5] = _createElementVNode("label", {
        for: "main-footer-favorite-tab",
        name: "tab-label"
      }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: "お気に入り",
          class: "main-footer-favorite-icon"
        })
      ], -1 /* HOISTED */))
    ]),
    _createElementVNode("div", {
      class: "main-footer-applied",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (tabClicked(1)))
    }, [
      _createElementVNode("input", {
        id: "main-footer-applied-tab",
        type: "radio",
        name: "tab_switch",
        checked: _unref(projectStore).selectedTab == 1
      }, null, 8 /* PROPS */, _hoisted_4),
      _createElementVNode("label", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("img", {
          src: _imports_2,
          alt: "応募中",
          class: "main-footer-applied-icon"
        }, null, -1 /* HOISTED */)),
        _withDirectives(_createElementVNode("span", {
          style: _normalizeStyle([
            _unref(projectStore).notification.total > 9
              ? 'width: 30px;'
              : 'width: 16px;',
          ])
        }, _toDisplayString(_unref(projectStore).notification.total), 5 /* TEXT, STYLE */), [
          [_vShow, _unref(projectStore).notification.total > 0]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "main-footer-mypage",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (tabClicked(2)))
    }, [
      _createElementVNode("input", {
        id: "main-footer-mypage-tab",
        type: "radio",
        name: "tab_switch",
        checked: _unref(projectStore).selectedTab == 2
      }, null, 8 /* PROPS */, _hoisted_6),
      _cache[7] || (_cache[7] = _createElementVNode("label", { for: "main-footer-mypage-tab" }, [
        _createElementVNode("img", {
          src: _imports_3,
          alt: "マイページ",
          class: "main-footer-mypage-icon"
        })
      ], -1 /* HOISTED */))
    ])
  ]))
}
}

})